import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  projectId: "meeting-minutes-app-7617f",
  appId: "1:707480985052:web:39eb2b2bed7bd5dc4e0319",
  storageBucket: "meeting-minutes-app-7617f.firebasestorage.app",
  apiKey: "AIzaSyCs5oeEZeLgxM8Ni9ZX9qJb85UazdEw2SI",
  authDomain: "app.kensetudx.com",
  messagingSenderId: "707480985052",
  measurementId: "G-TG5WEP59E5",
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'asia-northeast1');
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// iOS アプリは Apple サインインのみ（login_screen.dart）。Apple の uid は
// Google の uid と別物なので、ダッシュボードが Google ログインだけだと
// iPhone で録った議事録が一件も表示されない。Apple も選べるようにする。
// ※ 有効化には Firebase Console の Apple プロバイダ設定（Services ID /
//   Team ID / Key ID / 秘密鍵）と、Apple Developer 側の Return URL 登録
//   （https://app.kensetudx.com/__/auth/handler）が必要。
export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');
